module.exports = __webpack_public_path__ + "img/安全管理示例图_2.a41de2fa.png";